import {
    VIRTUAL_BUNDLE_SALES_SUCCESS,
    VIRTUAL_BUNDLE_SALES_LOADING
} from '../actions/VirtualBundleSalesAction';

const initialState = {
    amazon: {
        virtualBundleSalesData: null,
        isLoading: true
    },
    shopify: {
        virtualBundleSalesData: null,
        isLoading: true
    },
    wholesale: {
        virtualBundleSalesData: null,
        isLoading: true
    },
};

const virtualBundleSales = (state = initialState, action = {}) => {

    switch (action.type) {
        case VIRTUAL_BUNDLE_SALES_SUCCESS:
            return {
                ...state, virtualBundleSalesData: action.data, isLoading: false
            };
        case VIRTUAL_BUNDLE_SALES_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default virtualBundleSales;
